import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const TYPE_COLORS = {
  info:    { bg: 'rgba(0,136,204,0.15)', border: '#0088cc', text: '#5bc8ff', icon: 'ℹ️' },
  warning: { bg: 'rgba(245,196,0,0.12)', border: '#f5c400', text: '#f5c400', icon: '⚠️' },
  success: { bg: 'rgba(16,185,129,0.12)', border: '#10b981', text: '#10b981', icon: '✅' },
  promo:   { bg: 'rgba(124,58,237,0.15)', border: '#7c3aed', text: '#a78bfa', icon: '🎉' },
};

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [current, setCurrent] = useState(0);
  const [dismissed, setDismissed] = useState(new Set());

  useEffect(() => {
    api.get('/announcements').then(({ data }) => {
      setAnnouncements(data.announcements || []);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (announcements.length <= 1) return;
    const timer = setInterval(() => setCurrent(c => (c + 1) % announcements.length), 5000);
    return () => clearInterval(timer);
  }, [announcements]);

  const visible = announcements.filter(a => !dismissed.has(a._id));
  if (visible.length === 0) return null;

  const ann = visible[current % visible.length];
  if (!ann) return null;

  const style = TYPE_COLORS[ann.type] || TYPE_COLORS.info;

  return (
    <div style={{ background: style.bg, borderBottom: `1px solid ${style.border}`, padding: '10px 0', position: 'relative', zIndex: 800, marginTop: 70 }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
          <span style={{ fontSize: 16, flexShrink: 0 }}>{style.icon}</span>
          <p style={{ color: style.text, fontSize: 14, fontWeight: 600, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {ann.message}
          </p>
          {ann.link && ann.linkText && (
            <a href={ann.link} style={{ color: '#f5c400', fontWeight: 700, fontSize: 13, flexShrink: 0, textDecoration: 'underline' }}>
              {ann.linkText} →
            </a>
          )}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          {visible.length > 1 && (
            <div style={{ display: 'flex', gap: 4 }}>
              {visible.map((_, i) => (
                <div key={i} onClick={() => setCurrent(i)} style={{ width: 6, height: 6, borderRadius: '50%', background: i === current % visible.length ? style.text : 'rgba(255,255,255,0.3)', cursor: 'pointer', transition: 'all 0.2s' }} />
              ))}
            </div>
          )}
          <button onClick={() => setDismissed(new Set([...dismissed, ann._id]))} style={{ background: 'transparent', border: 'none', color: style.text, cursor: 'pointer', fontSize: 16, opacity: 0.7, padding: '0 4px' }}>✕</button>
        </div>
      </div>
    </div>
  );
}
